import React from 'react';
import ContentLoader from 'react-content-loader';

const confirmOfferSkel = <ContentLoader speed={1} viewBox="50 40 400 430" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* cadre */}
    <rect x="106" y="70" width="295" height="3" />
    <rect x="106" y="70" rx="0" ry="0" width="3" height="200" />
    <rect x="398" y="70" rx="0" ry="0" width="3" height="200" />
    {/* formulaire offre */}
    <circle cx="150" cy="120" r="25" />
    <rect x="190" y="100" width="100" height="10" />
    <rect x="190" y="120" width="150" height="10" />
    <rect x="126" y="160" width="100" height="10" />
    <rect x="126" y="180" width="250" height="50" />
    <rect x="126" y="240" width="150" height="10" />
    <rect x="106" y="260" width="295" height="120" />
    {/* bouton */}
    <rect x="330" y="405" rx="0" ry="0" width="70" height="25" />
</ContentLoader>
const identitySkel = <ContentLoader speed={1} viewBox="0 0 300 350" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <rect x="40" y="10" rx="0" ry="0" width="150" height="10" />
    <rect x="40" y="33" rx="0" ry="0" width="42" height="10" />
    <circle cx="44" cy="52" r="3" />
    <rect x="50" y="48" rx="0" ry="0" width="40" height="7" />
    <circle cx="100" cy="52" r="3" />
    <rect x="110" y="48" rx="0" ry="0" width="40" height="7" />
    {/* nom et prenom */}
    <rect x="40" y="66" rx="0" ry="0" width="23" height="10" />
    <rect x="40" y="82" rx="0" ry="0" width="110" height="15" />

    <rect x="164" y="66" rx="0" ry="0" width="23" height="9" />
    <rect x="164" y="82" rx="0" ry="0" width="110" height="15" />
    {/* date de naissance */}
    <rect x="40" y="110" rx="0" ry="0" width="43" height="10" />
    <rect x="40" y="125" rx="0" ry="0" width="87" height="15" />
    {/* pays naissance */}
    <rect x="40" y="150" rx="0" ry="0" width="43" height="10" />
    <rect x="40" y="165" rx="0" ry="0" width="110" height="15" />

    <rect x="164" y="150" rx="0" ry="0" width="43" height="9" />
    <rect x="164" y="165" rx="0" ry="0" width="110" height="15" />
    {/* adresse  */}
    <rect x="40" y="190" rx="0" ry="0" width="43" height="10" />
    <rect x="40" y="205" rx="0" ry="0" width="110" height="15" />
    {/* tel  */}
    <rect x="40" y="230" rx="0" ry="0" width="43" height="10" />
    <rect x="40" y="245" rx="0" ry="0" width="110" height="15" />
    {/* tel  */}
    <rect x="40" y="270" rx="0" ry="0" width="43" height="10" />
    <rect x="40" y="285" rx="0" ry="0" width="110" height="15" />
    {/* bouton */}
    <rect x="6" y="325" rx="0" ry="0" width="70" height="18" />
    <rect x="225" y="325" rx="0" ry="0" width="70" height="18" />

</ContentLoader>
const howToJoinSkel = <ContentLoader speed={1} viewBox="0 0 370 290" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <rect x="40" y="10" rx="0" ry="0" width="150" height="10" />

    <rect x="40" y="43" rx="0" ry="0" width="43" height="10" />
    <rect x="40" y="60" rx="0" ry="0" width="137" height="15" />

    <rect x="184" y="43" rx="0" ry="0" width="43" height="9" />
    <rect x="184" y="60" rx="0" ry="0" width="140" height="15" />
    {/* Complément d'adresse */}
    <rect x="40" y="85" rx="0" ry="0" width="43" height="10" />
    <rect x="40" y="100" rx="0" ry="0" width="285px" height="15" />
    {/* Code postal Ville */}
    <rect x="40" y="130" rx="0" ry="0" width="43" height="10" />
    <rect x="40" y="145" rx="0" ry="0" width="90" height="15" />

    <rect x="140" y="130" rx="0" ry="0" width="43" height="9" />
    <rect x="140" y="145" rx="0" ry="0" width="170" height="15" />
    {/* pays  */}
    <rect x="40" y="170" rx="0" ry="0" width="43" height="10" />
    <rect x="40" y="190" rx="0" ry="0" width="285px" height="15" />

    <rect x="40" y="220" rx="0" ry="0" width="285px" height="35" />
    {/* bouton */}
    <rect x="6" y="260" rx="0" ry="0" width="80" height="23" />
    <rect x="280" y="260" rx="0" ry="0" width="80" height="23" />

</ContentLoader>
const bankAccountInfoSkel = <ContentLoader speed={1} viewBox="0 0 370 260" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <rect x="40" y="10" rx="0" ry="0" width="140" height="10" />
    {/* Nom du titulaire du compte */}
    <rect x="40" y="43" rx="0" ry="0" width="100" height="10" />
    <rect x="40" y="60" rx="0" ry="0" width="220" height="15" />

    {/* IBAN*/}
    <rect x="40" y="85" rx="0" ry="0" width="30" height="10" />
    <rect x="40" y="100" rx="0" ry="0" width="220" height="15" />
    {/* BIC  */}
    <rect x="40" y="130" rx="0" ry="0" width="30" height="10" />
    <rect x="40" y="145" rx="0" ry="0" width="220" height="15" />

    <rect x="40" y="180" rx="0" ry="0" width="285" height="35" />
    {/* bouton */}
    <rect x="6" y="230" rx="0" ry="0" width="80" height="23" />
    <rect x="280" y="230" rx="0" ry="0" width="80" height="23" />
</ContentLoader>
const summarySkel = <ContentLoader speed={1} viewBox="0 0 370 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* title */}
    <rect x="26" y="40" rx="0" ry="0" width="200" height="10" />
    {/* hr haut */}
    <rect x="26" y="70" width="300" height="3" />
    {/* hr gauche */}
    <rect x="26" y="70" rx="0" ry="0" width="3" height="160" />
    {/* hr mid */}
    <rect x="180" y="70" rx="0" ry="0" width="3" height="160" />
    {/* hr droit */}
    <rect x="325" y="70" rx="0" ry="0" width="3" height="160" />
    {/* hr botom */}
    <rect x="26" y="230" width="302" height="3" />
    {/* info ofre */}
    <circle cx="50" cy="72" r="20" />
    <rect x="36" y="105" rx="0" ry="0" width="100" height="10" />
    <rect x="36" y="130" rx="0" ry="0" width="120" height="8" />
    <rect x="36" y="148" rx="0" ry="0" width="14" height="15" />
    <rect x="57" y="150" rx="0" ry="0" width="110" height="8" />
    <rect x="36" y="170" rx="0" ry="0" width="60" height="8" />
    {/* EnsuredList */}
    <rect x="190" y="90" rx="0" ry="0" width="14" height="15" />
    <rect x="210" y="94" rx="0" ry="0" width="100" height="8" />
    <rect x="210" y="108" rx="0" ry="0" width="50" height="8" />

    <rect x="190" y="128" rx="0" ry="0" width="14" height="15" />
    <rect x="210" y="128" rx="0" ry="0" width="100" height="8" />
    <rect x="210" y="140" rx="0" ry="0" width="70" height="8" />

    <rect x="190" y="158" rx="0" ry="0" width="14" height="15" />
    <rect x="210" y="158" rx="0" ry="0" width="100" height="8" />
    <rect x="210" y="170" rx="0" ry="0" width="80" height="8" />
    <rect x="210" y="184" rx="0" ry="0" width="50" height="8" />

    {/* title information perso */}
    <rect x="26" y="240" rx="0" ry="0" width="100" height="10" />
    {/* hr haut */}
    <rect x="26" y="260" width="136" height="3" />
    <rect x="180" y="260" width="145" height="3" />
    {/* hr gauche */}
    <rect x="26" y="260" rx="0" ry="0" width="3" height="130" />
    {/* hr mid */}
    <rect x="160" y="260" rx="0" ry="0" width="3" height="130" />
    <rect x="180" y="260" rx="0" ry="0" width="3" height="130" />
    {/* hr droit */}
    <rect x="325" y="260" rx="0" ry="0" width="3" height="130" />
    {/* hr botom */}
    <rect x="26" y="390" width="136" height="3" />
    <rect x="180" y="390" width="148" height="3" />
    {/* Vos informations personnelles */}
    <rect x="36" y="275" rx="0" ry="0" width="80" height="10" />
    <rect x="36" y="290" rx="0" ry="0" width="50" height="8" />
    <rect x="136" y="275" rx="0" ry="0" width="14" height="13" />
    <rect x="36" y="310" rx="0" ry="0" width="100" height="8" />
    <rect x="36" y="327" rx="0" ry="0" width="80" height="8" />
    <rect x="36" y="340" rx="0" ry="0" width="100" height="8" />
    <rect x="36" y="353" rx="0" ry="0" width="50" height="8" />
    <rect x="36" y="367" rx="0" ry="0" width="90" height="8" />
    {/* Vos coordonnées bancaires */}
    <rect x="300" y="275" rx="0" ry="0" width="14" height="13" />
    <rect x="190" y="275" rx="0" ry="0" width="100" height="10" />
    <rect x="190" y="310" rx="0" ry="0" width="50" height="8" />
    <rect x="190" y="335" rx="0" ry="0" width="120" height="8" />
    <rect x="190" y="350" rx="0" ry="0" width="120" height="8" />
    {/* info box */}
    <rect x="26" y="400" rx="0" ry="0" width="300" height="35" />
    {/* bouton */}
    <rect x="6" y="450" rx="0" ry="0" width="80" height="23" />
    <rect x="280" y="450" rx="0" ry="0" width="80" height="23" />
</ContentLoader>
const signatureSkel = <ContentLoader speed={1} viewBox="0 0 370 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* 1 point */}
    <rect x="26" y="23" rx="0" ry="0" width="5" height="5" />
    <rect x="46" y="21" rx="0" ry="0" width="250" height="8" />
    <rect x="46" y="35" rx="0" ry="0" width="50" height="8" />
    {/* 2 point */}
    <rect x="26" y="53" rx="0" ry="0" width="5" height="5" />
    <rect x="46" y="51" rx="0" ry="0" width="250" height="8" />
    <rect x="46" y="65" rx="0" ry="0" width="50" height="8" />
    {/* 3 point */}
    <rect x="26" y="83" rx="0" ry="0" width="5" height="5" />
    <rect x="46" y="81" rx="0" ry="0" width="250" height="8" />
    <rect x="46" y="95" rx="0" ry="0" width="50" height="8" />
    {/* signature */}
    <rect x="26" y="115" rx="0" ry="0" width="300" height="250" />

</ContentLoader>
const cancellationSkel = <ContentLoader speed={1} viewBox="0 0 370 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <circle cx="190" cy="52" r="40" />

    <rect x="66" y="121" rx="0" ry="0" width="250" height="12" />
    <rect x="126" y="145" rx="0" ry="0" width="130" height="12" />

    <rect x="26" y="181" rx="0" ry="0" width="325" height="8" />
    <rect x="126" y="201" rx="0" ry="0" width="100" height="8" />
</ContentLoader>
const confirmationSkel = <ContentLoader speed={1} viewBox="0 0 370 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <circle cx="190" cy="52" r="40" />

    <rect x="86" y="121" rx="0" ry="0" width="200" height="12" />
    <rect x="136" y="145" rx="0" ry="0" width="110" height="12" />

    <rect x="96" y="181" rx="0" ry="0" width="180" height="8" />
    <rect x="96" y="201" rx="0" ry="0" width="180" height="8" />

    <rect x="86" y="241" rx="0" ry="0" width="210" height="8" />
    <rect x="160" y="281" rx="0" ry="0" width="50" height="8" />
</ContentLoader>
const enterpriseIdentitySkel = <ContentLoader speed={1} viewBox="0 0 370 290" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    {/* dénomination */}
    <rect x="40" y="10" rx="0" ry="0" width="80" height="10" />
    <rect x="40" y="30" rx="0" ry="0" width="137" height="20" />
    {/* titre rep légal */}
    <rect x="200" y="10" rx="0" ry="0" width="80" height="9" />
    <rect x="200" y="30" rx="0" ry="0" width="137" height="20" />
    {/* rep légal */}
    <rect x="40" y="65" rx="0" ry="0" width="80" height="10" />
    <rect x="40" y="85" rx="0" ry="0" width="137" height="20" />
    {/* SIRET */}
    <rect x="200" y="65" rx="0" ry="0" width="40" height="10" />
    <rect x="200" y="85" rx="0" ry="0" width="137" height="20" />
    {/* bouton */}
    <rect x="6" y="130" rx="0" ry="0" width="80" height="23" />
    <rect x="280" y="130" rx="0" ry="0" width="80" height="23" />

</ContentLoader>
const tooLateSkel = <ContentLoader speed={1} viewBox="0 0 370 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <rect x="146" y="32" rx="0" ry="0" width="80" height="35" />
    <rect x="120" y="76" rx="0" ry="0" width="135" height="12" />
</ContentLoader>
const tooEarlySkel = <ContentLoader speed={1} viewBox="0 0 370 500" backgroundColor="#d5d5d5" foregroundColor="#ecebeb">
    <rect x="66" y="32" rx="0" ry="0" width="255" height="16" />
    <rect x="126" y="56" rx="0" ry="0" width="135" height="16" />

    <circle cx="190" cy="118" r="40" />
</ContentLoader>
export const associativeSkelMap = new Map<string, any>([
    ['confirmOfferStep', confirmOfferSkel],
    ['recommendedOfferStep', confirmOfferSkel],
    ['enterpriseIdentityStep', enterpriseIdentitySkel],
    ['identityStep', identitySkel],
    ['howToJoinStep', howToJoinSkel],
    ['bankAccountInfoStep', bankAccountInfoSkel],
    ['summaryStep', summarySkel],
    ['signatureStep', signatureSkel],
    ['confirmationStep', confirmationSkel],
    ['confirmationBarcodeStep', confirmationSkel],
    ['cancellationStep', cancellationSkel],
    ['customerInformationStep', identitySkel],
    ['insuredElementStep', identitySkel],
    ['tooLateStep', tooLateSkel], // TODO: add tooLateSkle
    ['tooEarlyStep', tooEarlySkel], // TODO: add tooEarlyStep
    ['paymentStep', confirmationSkel],
    ['paymentConfirmationStep', confirmationSkel], // TODO: POS
    ['paymentFailureStep', confirmationSkel],
]);
